// extracted by mini-css-extract-plugin
export default {"messageWrapper":"lastConfirmPage_messageWrapper__ze7XR"};